export default __webpack_public_path__ + "static/media/menu_arrow_white.78a81584.svg";